// @ts-nocheck
/* eslint-disable */
export const appReadyV224Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5.25" y="5.25" width="13.5" height="13.5" rx="6.75" fill="currentColor"/><path d="M8.89732 13.3381L11.0361 14.8157C11.1639 14.904 11.3391 14.872 11.4274 14.7442L14.7944 9.87059" stroke="#FAFBFB" stroke-width="1.5" stroke-linecap="round"/></svg>`,
    name: 'ready-v-2-24' as const
};